"use client";

import { AppTextField } from "@/common";
import {
  DateTimePicker,
  DateTimePickerProps,
  DateTimePickerToolbarProps,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs, { Dayjs } from "dayjs";
import "dayjs/locale/vi";
import updateLocale from "dayjs/plugin/updateLocale";
import { forwardRef, memo } from "react";

dayjs.extend(updateLocale);

dayjs.updateLocale("vi", {
  months: [
    "Tháng 1",
    "Tháng 2",
    "Tháng 3",
    "Tháng 4",
    "Tháng 5",
    "Tháng 6",
    "Tháng 7",
    "Tháng 8",
    "Tháng 9",
    "Tháng 10",
    "Tháng 11",
    "Tháng 12",
  ],
});

const dayOfWeekVn = {
  0: "CN",
  1: "T2",
  2: "T3",
  3: "T4",
  4: "T5",
  5: "T6",
  6: "T7",
};

const CustomDateTimePickerToolbar = (
  _: DateTimePickerToolbarProps<Dayjs>,
) => {
  return null;
};

const AppDateTimePicker = forwardRef<
  HTMLInputElement,
  DateTimePickerProps<Dayjs> & { size?: "medium" | "small" }
>(
  (
    {
      sx,
      size = "medium",
      ...props
    }: DateTimePickerProps<Dayjs> & {
      size?: "medium" | "small";
    },
    ref,
  ) => {
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
        <DemoContainer components={["DateTimePicker"]}>
          <DateTimePicker
            inputRef={ref}
            dayOfWeekFormatter={(day) => dayOfWeekVn[day.day()]}
            slots={{
              textField: AppTextField,
              toolbar: CustomDateTimePickerToolbar,
            }}
            views={["year", "month", "day", "hours", "minutes"]}
            openTo="day"
            ampm={false}
            format="DD/MM/YYYY HH:mm"
            sx={{
              "& .MuiPickersCalendarHeader-label": {
                "&::first-letter": {
                  textTransform: "uppercase !important",
                },
              },
              ...sx,
            }}
            {...props}
            slotProps={{
              ...props.slotProps,
              textField: {
                fullWidth: true,
                className: "",
                size,
                ...props.slotProps?.textField,
              },
            }}
          />
        </DemoContainer>
      </LocalizationProvider>
    );
  },
);

AppDateTimePicker.displayName = "AppDateTimePicker";

export default memo(AppDateTimePicker);
